import React from "react";

function PageSizeSelector({ pageSize, setPageSize }) {
  return (
    <div className="flex items-center gap-2 text-sm">
      <span>Rows:</span>

      <select
        value={pageSize}
        onChange={(e) => setPageSize(Number(e.target.value))}
        className="border rounded px-2 py-1"
      >
        {/* <option value={2}>2</option> */}

        <option value={10}>10</option>
        <option value={20}>20</option>
        <option value={30}>30</option>
        <option value={50}>50</option>
      </select>
    </div>
  );
}

export default PageSizeSelector;